import generateUtilityClass from '@mui/base/generateUtilityClass';
import generateUtilityClasses from '@mui/base/generateUtilityClasses';
export function getSplitButtonUtilityClass(slot) {
  return generateUtilityClass('OriMuiSplitButton', slot);
}
const splitButtonClasses = generateUtilityClasses('OriMuiSplitButton', ['root', 'button', 'content', 'colorPrimary', 'colorSecondary', 'fullWidth', 'sizeMedium', 'sizeSmall', 'disabled', 'loading', 'edgeEnd', 'edgeStart']);
export default splitButtonClasses;